import { useState } from "react";
import Card from "./Card";
import Sparkline, { type SparkPoint } from "./Sparkline";

interface ActivityMetricCardProps {
  label: React.ReactNode;
  loading?: boolean;
  data?: SparkPoint[];
  value: string;
  unit?: string;
  ltr?: boolean;
  changePercent: number | null;
  formatValue: (v: number) => string;
  formatTime: (iso: string) => string;
}

export default function ActivityMetricCard({
  label,
  loading,
  data,
  value,
  unit,
  ltr,
  changePercent,
  formatValue,
  formatTime,
}: ActivityMetricCardProps) {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const points = data || [];
  const hovered = hoveredIndex != null ? points[hoveredIndex] : null;

  const changeLabel =
    changePercent == null
      ? null
      : {
          text: `${Math.abs(changePercent).toLocaleString("fa-IR", { maximumFractionDigits: 2 })}٪`,
          color: changePercent >= 0 ? "#22B06E" : "#E5484D",
          arrow: changePercent >= 0 ? "↑ +" : "↓ −",
        };

  return (
    <Card padding="md" className="flex flex-col">
      <p className="text-small font-bold text-text-main">{label}</p>
      <div className="mt-3 flex items-baseline gap-1.5">
        {loading ? (
          <div className="h-9 w-28 bg-surface-hover rounded animate-pulse" />
        ) : (
          <span className="text-h1 text-text-main font-number leading-none" dir={ltr ? "ltr" : undefined}>
            {hovered ? formatValue(hovered.value) : value}
            {unit ? <span className="text-body text-text-tertiary font-normal mr-1">{unit}</span> : null}
          </span>
        )}
      </div>
      <div className="mt-2 min-h-[20px]">
        {hovered ? (
          <p className="text-small font-medium text-text-secondary">{formatTime(hovered.time)}</p>
        ) : changeLabel ? (
          <p className="text-small font-semibold" dir="ltr" style={{ color: changeLabel.color }}>
            {changeLabel.arrow}
            {changeLabel.text}
          </p>
        ) : (
          <p className="text-small text-text-tertiary">داده دوره‌ی قبلی وجود ندارد</p>
        )}
      </div>
      <div className="mt-auto pt-3">
        <Sparkline data={points} hoveredIndex={hoveredIndex} onHover={setHoveredIndex} />
      </div>
    </Card>
  );
}
